// extracted by mini-css-extract-plugin
export var cardElement = "CardsContainer-module--cardElement--7dcb7";
export var container = "CardsContainer-module--container--19b7d";
export var pagination = "CardsContainer-module--pagination--589d3";
export var wrapper = "CardsContainer-module--wrapper--8cb0f";